import { useMemo } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useFetch } from "../../core/hooks/useFetch";
import { IBandeiraCartao } from "../interface/IBandeiraCartao";

/**
 * @param apenasAtivas usar `true` nos selects de pagamento, para não oferecer bandeiras
 * desativadas; a tela de cadastro lista todas.
 */
export const useFetchBandeirasCartao = (apenasAtivas?: boolean) => {
    const api = useMemo(() => ApiFactory.getApi("MS_PEDIDOS"), []);
    const url = apenasAtivas ? '/bandeiras?ativo=true' : '/bandeiras';

    const { data, error, isLoading, mutate } = useFetch<IBandeiraCartao[]>(api, url);

    return { bandeiras: data ?? [], error, isLoading, mutate };
}
